import { Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { CanTakeAttachment } from '../../../..//shared/mixins/can-take-picture';
import { applyMixins, Attachment, NotificationService } from 'wms-lib';
import { TicketAttachmentsBaseComponent } from './ticket-attachments.component.base';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-ticket-attachments',
  templateUrl: './ticket-attachments.component.html',
  styleUrls: ['./ticket-attachments.component.scss']
})
export class TicketAttachmentsComponent extends TicketAttachmentsBaseComponent {
  takeAttachmentImage: (image: File) => Promise<void>;
  uploadValidationErrors: string[] = [];

  constructor(store: Store, private confirmationService: ConfirmationService, private notificationService: NotificationService) {
    super(store);
  }

  onFileSelect(event, uploader) {
    this.validatePendingFiles(uploader.files);
  }

  onFileRemove(event, uploader) {
    const files = uploader.files.filter(f => f !== event.file);
    this.validatePendingFiles(files);
  }

  validatePendingFiles(files: File[]) {
    const validation = this.validateFileRestrictions(files, false);
    this.uploadValidationErrors = validation.valid ? [] : validation.errors;
  }

  uploadFiles(event,uploader) {
    const validation = this.validateFileRestrictions(event.files, false);
    if (!validation.valid) {
      this.notificationService.toast(validation.errors.join('\n'), true, { severity: 'error', summary: 'File Restriction Error' });
      uploader.clear();
      return;
    }

    this.ticket.removeNotPersistedAttachments();
    event.files.forEach(att => this.ticket.appendAttachmentFromFile(att));
    this.save().subscribe(() => uploader.clear());
  }

  openFile(src: string) {
    window.open(src);
  }

  deleteFile(attachment: Attachment){
	  this.confirmationService.confirm({
		  message: 'Are you sure that you want to delete this attachment?',
		  accept: () => this.deleteSingleAttachment(attachment)
	  });
  }

  get isUploadDisabled(): boolean {
    const status = this.currentFileStatus;
    return status.length > 0 && status.every(s => s.current >= s.max);
  }

  get showFileUploader(): boolean {
    return !!this.ticket && (!this.ticket.isNew && this.ticket.status_key != 'O');
  }

}



applyMixins(TicketAttachmentsComponent, [CanTakeAttachment]);
